jQuery(document).ready(function($) {
  // Only run if the element exists
  if ($('.emi-mobile .owl-carousel').length && $.fn.owlCarousel) {

    // Remove load class
    $('.emi-mobile').removeClass('remove-cls-load');

    // Initialize owl
    $('.emi-mobile .owl-carousel').owlCarousel({
      loop: true,
      nav: false,
      dots: false,
      autoplay: true,
      autoplayTimeout: 2000,
      autoplayHoverPause: true,
      responsive: {
        0: { items: 1, nav: false, },
        600: { items: 1, nav: false, },
        1000: { items: 2, nav: false, }
      }
    });

  } else {
    console.warn("OwlCarousel not initialized: either .emi-mobile .owl-carousel not found or plugin missing.");
  }
});


  document.addEventListener("DOMContentLoaded", function () {
    const productWrappers = document.querySelectorAll('.product_img_btn_inner');

    productWrappers.forEach(wrapper => {
      const slider = wrapper.querySelector('.img_inner');
      const dots = wrapper.querySelectorAll('.mobile-image-dots span');

      if (!slider || dots.length === 0) return;

      slider.addEventListener('scroll', () => {
        const scrollLeft = slider.scrollLeft;
        const slideWidth = slider.clientWidth;
        const index = Math.round(scrollLeft / slideWidth);

        dots.forEach((dot, i) => {
          dot.classList.toggle('active', i === index);
        });
      });
    });
  });


   document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.swatch .header').forEach(header => {
      header.addEventListener('click', function () {
        const swatch = this.closest('.swatch');
        swatch.classList.toggle('active');
      });
    });
  });


  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.custom_product_show .header').forEach(header => {
      header.addEventListener('click', function () {
        const wrapper = this.closest('.custom_product_show');
        wrapper.classList.toggle('active');
      });
    });
  });




